import { Component, inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { DomSanitizer, Meta, SafeHtml, Title } from '@angular/platform-browser';
import { PayloadService } from '../../services/payload.service';
import { ChiSiamo } from '../../types/payload-types';

@Component({
  selector: 'app-chi-siamo',
  imports: [],
  templateUrl: './chi-siamo.component.html',
  styleUrl: './chi-siamo.component.scss',
})
export class ChiSiamoComponent implements OnInit {
  html: SafeHtml | null = null;

  private payloadService = inject(PayloadService);
  private sanitizer = inject(DomSanitizer);
  private meta = inject(Meta);
  private title = inject(Title);
  private document = inject(DOCUMENT);

  ngOnInit(): void {
    this.payloadService.getChiSiamo().subscribe((res: ChiSiamo) => {
      if (res.descriptionHTML) {
        this.html = this.sanitizer.bypassSecurityTrustHtml(res.descriptionHTML);
        this.setSeoMeta(res.descriptionHTML);
        this.setJsonLd(res.descriptionHTML);
      }
    });
  }

  private setSeoMeta(descriptionHtml: string): void {
    const plainText = this.getPlainText(descriptionHtml);
    const pageTitle = 'Chi Siamo | ComeTralci';
    const description = plainText || 'Scopri chi siamo: la storia, la missione e i valori di ComeTralci, comunità di chiese evangeliche in Italia.';
    const canonicalUrl = 'https://cometralci.com/chi-siamo';

    this.title.setTitle(pageTitle);
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:url', content: canonicalUrl });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:image', content: 'https://cometralci.com/images/photo17.JPG' });
    this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.meta.updateTag({ name: 'twitter:title', content: pageTitle });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({ name: 'twitter:image', content: 'https://cometralci.com/images/photo17.JPG' });
    this.updateCanonicalUrl(canonicalUrl);
  }

  private setJsonLd(descriptionHtml: string): void {
    const plainText = this.getPlainText(descriptionHtml);

    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'ComeTralci',
      url: 'https://cometralci.com',
      description: plainText,
      image: 'https://cometralci.com/images/photo17.JPG',
      sameAs: [
        'https://cometralci.com',
      ],
    };

    const existing = this.document.getElementById('chi-siamo-jsonld');
    if (existing) existing.remove();

    const script = this.document.createElement('script');
    script.id = 'chi-siamo-jsonld';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(jsonLd);
    this.document.head.appendChild(script);
  }

  private getPlainText(html: string): string {
    return html
      .replace(/<[^>]+>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .substring(0, 160);
  }

  private updateCanonicalUrl(url: string): void {
    let link = this.document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.document.head.appendChild(link);
    }
    link.setAttribute('href', url);
  }
}
